import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen, FileText, AlertCircle } from 'lucide-react';

const DocumentChecklist = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <FileText className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Document Checklist
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Complete list of required documents for your residence permit application
          </p>
        </div>

        <div className="space-y-8">
          <Card>
            <CardHeader>
              <div className="flex items-center space-x-3">
                <FileText className="h-6 w-6 text-primary" />
                <CardTitle>Required Documents</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="list-disc pl-6 space-y-2">
                <li>Completed and signed application form</li>
                <li>Valid passport (original + copies of all pages)</li>
                <li>Current photographs (35x45mm, white background)</li>
                <li>Proof of payment for residence card fee</li>
                <li>Confirmation of registered address (zameldowanie)</li>
                <li>Health insurance documentation</li>
                <li>Bank statements or other proof of financial means</li>
                <li>Documents specific to your purpose of stay:
                  <ul className="list-disc pl-6 mt-2">
                    <li>Employment contract (for work)</li>
                    <li>University enrollment (for studies)</li>
                    <li>Business registration (for entrepreneurs)</li>
                    <li>Marriage certificate (for family reunification)</li>
                  </ul>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className="flex items-center space-x-3">
                <AlertCircle className="h-6 w-6 text-yellow-500" />
                <CardTitle>Document Requirements</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="list-disc pl-6 space-y-2">
                <li>All documents must be translated into Polish by a sworn translator</li>
                <li>Bring originals and copies of all documents</li>
                <li>Documents should be no older than 3 months</li>
                <li>Ensure all copies are clear and legible</li>
                <li>Some documents may require apostille or legalization</li>
              </ul>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/knowledge-base/getting-started')}
            className="text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Getting Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentChecklist; 